module.exports = __webpack_public_path__ + "static/media/YekanBakh-Medium.c7d275c3.woff";